export default function verified({ next, store }) {

    if (!store.state.auth.email) next('/forgot-password')

    else next()

}